import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';

function Bool(props) {
    
    const t = useTranslate();   

    const handleChange = (value) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    return(
        <div className="wizardFieldBool">
            <p style={{marginBottom: "4px"}}>{props.title}</p>
            <Button
                disabled={
                    props.disabled ||
                    (props.value !== undefined ? (props.value !== "" ? props.value : false) : (props.defaultValue !== "" ? props.defaultValue : false))
                }
                onClick={() => handleChange(true)}
                className="truebtn"
            >
                {props.options != undefined && props.options.positive != undefined ? props.options.positive : t("system_wizard.yes")}
            </Button>
            <Button
                disabled={
                    props.disabled ||
                    (props.value !== undefined ? (props.value !== "" ? !props.value : false) : (props.defaultValue !== "" ? !props.defaultValue : false))
                }
                onClick={() => handleChange(false)}
                className="falsebtn"
            >
                {props.options != undefined && props.options.negative != undefined ? props.options.negative : t("system_wizard.no")}
            </Button>
        </div>
    );
}

export default Bool;